import { useMemo } from "react";
import { FlowState } from "./types";

export const useStepManagement = (flowState: FlowState) => {
  const getActiveStep = useMemo(() => {
    switch (flowState) {
      case "initial":
        return 0;
      case "processing":
        return 1;
      case "generalExtracted":
        return 1;
      case "detailedProcessing":
        return 2;
      case "detailedExtracted":
        return 2;
      case "saving":
        return 3;
      case "saved":
        return 4;
      default:
        return 0;
    }
  }, [flowState]);

  return {
    getActiveStep,
  };
};